
function getStoreBearer () {
  let auth = window.localStorage.getItem('sellsuki.store.bearer')
  return auth
}

function getSellsukiUser () {
  let user = window.localStorage.getItem('sellsuki.user')
  user = JSON.parse(user)
  return user
}

function getUser () {
  let user = window.localStorage.getItem('sellsuki.user')
  user = JSON.parse(user)
  const result = {
    id: user.user.id ? user.user.id : '',
    first_name: user.user.first_name ? user.user.first_name : '',
    last_name: user.user.last_name ? user.user.last_name : ''
  }
  return result
}

function getUserCashier () {
  let user = window.localStorage.getItem('sellsuki.user')
  user = JSON.parse(user)
  const result = {
    id: user.user.id ? parseInt(user.user.id) : 0,
    name: user.user.first_name ? `${user.user.first_name} ${user.user.last_name}` : '',
    email: user.user.email ? user.user.email : ''
  }
  return result
}

function getBranchID () {
  let results = window.localStorage.getItem('currentBranchPOS')
  return JSON.parse(results).branch_id
}
function getUnitID () {
  let results = window.localStorage.getItem('currentBranchPOS')
  return JSON.parse(results).unit_id
}
function getPOSID () {
  let results = window.localStorage.getItem('currentBranchPOS')
  return JSON.parse(results).pos_id
}
function getWerehouse () {
  let results = window.localStorage.getItem('currentBranchPOS')
  return JSON.parse(results).warehouse
}
function getBranchName () {
  let results = window.localStorage.getItem('currentBranchPOS')
  return results ? JSON.parse(results).name : ''
}
function getCurrentBranchPOS () {
  let getItem = window.localStorage.getItem('currentBranchPOS')
  const result = getItem ? JSON.parse(getItem) : ''
  return result
}
export {
  getStoreBearer,
  getUser,
  getBranchID,
  getUnitID,
  getPOSID,
  getWerehouse,
  getBranchName,
  getSellsukiUser,
  getCurrentBranchPOS,
  getUserCashier
}



// WEBPACK FOOTER //
// ./src/utils/helper/localStorage.js